// Generated by purs version 0.13.8
"use strict";
var Effect_Unsafe = require("../Effect.Unsafe/index.js");
var Specular_Internal_Incremental_Ref = require("../Specular.Internal.Incremental.Ref/index.js");
var stabilizationIsNotInProgress = -1 | 0;
var globalTotalRefcount = Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](0);
});
var globalLastStabilizationNum = Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](0);
});
var globalCurrentStabilizationNum = Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](stabilizationIsNotInProgress);
});
module.exports = {
    stabilizationIsNotInProgress: stabilizationIsNotInProgress,
    globalLastStabilizationNum: globalLastStabilizationNum,
    globalCurrentStabilizationNum: globalCurrentStabilizationNum,
    globalTotalRefcount: globalTotalRefcount
};
//# sourceMappingURL=index.js.map
